import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
class ServerClass {
    $q;
    constructor() {
        this.$q = useQuasar();
    }
    async getList() {
        const response = await this.$q.ws.sendRequest({
            type: 'query',
            iface: 'server',
            method: 'getList',
            args: {}
        });
        if (response && response.args && response.args.rows) {
            return response.args.rows;
        }
        else
            return null;
    }
    async getStatus(serverID) {
        const response = await this.$q.ws.sendRequest({
            type: 'query',
            iface: 'user',
            method: 'sendToServer',
            args: {
                id: serverID,
                method: 'getStatus'
            }
        });
        if (response && response.args && response.args) {
            // Если ошибка
            if (response.args.message) {
            }
            // Если всё ок
            else {
                const devices = [];
                const minerTypes = [];
                const boardTypes = [];
                Object.entries(response.args.device).forEach(([ip, props]) => {
                    const device = this.$q.class.Device.formatDeviceData(ip, null, props);
                    devices.push(device);
                    if (device.miner_type && !minerTypes.includes(device.miner_type)) {
                        minerTypes.push(device.miner_type);
                    }
                    if (device.miner_board_type && !boardTypes.includes(device.miner_board_type)) {
                        boardTypes.push(device.miner_board_type);
                    }
                });
                delete response.args.device;
                this.$q.store.farm.server = {
                    ...this.$q.store.farm.server,
                    ...response.args
                };
                this.$q.store.farm.devices = devices;
                this.$q.store.farm.minerTypes = minerTypes;
                this.$q.store.farm.boardTypes = boardTypes;
                this.$q.class.Device.setTable(devices);
            }
        }
        this.$q.store.farm.dataLoaded = true;
    }
}
export default ServerClass;
